module.exports = __webpack_public_path__ + "media/slow2.0f5b2638.mp4";